var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F8FCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.75C18.4142 18.75 18.75 18.4142 18.75 18C18.75 17.5858 18.4142 17.25 18 17.25C17.5858 17.25 17.25 17.5858 17.25 18C17.25 18.4142 17.5858 18.75 18 18.75Z",
    stroke: "#020202",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 18.75C23.6642 18.75 24 18.4142 24 18C24 17.5858 23.6642 17.25 23.25 17.25C22.8358 17.25 22.5 17.5858 22.5 18C22.5 18.4142 22.8358 18.75 23.25 18.75Z",
    stroke: "#020202",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 18.75C13.1642 18.75 13.5 18.4142 13.5 18C13.5 17.5858 13.1642 17.25 12.75 17.25C12.3358 17.25 12 17.5858 12 18C12 18.4142 12.3358 18.75 12.75 18.75Z",
    stroke: "#020202",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionIcon);
export default __webpack_public_path__ + "static/media/action-icon.407d9ea7fff2de0998e4d674f10f3e03.svg";
export { ForwardRef as ReactComponent };